import { createApi } from '@reduxjs/toolkit/query/react';
import { isMobile, isTablet } from 'react-device-detect';

import type { RootState } from '@/store';
import { baseQuery } from '@/store/api/baseQuery';

export interface EventLogRequest {
  event: string;
  filesize?: number;
}

export interface EventLogResponse {
  success: boolean;
  message?: string;
}

export const getDevice = () => {
  if (isMobile) return 'Cell';
  if (isTablet) return 'Tablet';
  return 'Desktop';
};

const getRequestPayload = (_event: string, filesize: number | undefined, state: RootState) => {
  const params = new URLSearchParams(location.search);
  const contactId = params.get('contactId') || undefined;
  const stipsId = state.auth.stipsId;

  let network = 'Unknown';
  if ('connection' in navigator) {
    const nav = navigator as Navigator & {
      connection?: { type?: string };
    };
    network = nav.connection?.type ?? 'Wifi';
  }

  return {
    contactIdTopLevel: contactId,
    stipGuid: stipsId ?? '',
    filesize: filesize?.toString(),
    stipsDevice: getDevice(),
    networkType: network,
  };
};

export const eventsApi = createApi({
  reducerPath: 'eventsApi',
  baseQuery,
  endpoints: (builder) => ({
    addEventLog: builder.mutation<EventLogResponse, EventLogRequest>({
      async queryFn({ event, filesize }, api, _extraOptions, baseQueryFn) {
        const state = api.getState() as RootState;

        const result = await baseQueryFn({
          url: `/stips/${event}/EventLog`,
          method: 'POST',

          body: getRequestPayload(event, filesize, state),
        });

        if (result.error) {
          return {
            error: result.error,
          };
        }

        return {
          data: result.data as EventLogResponse,
        };
      },

      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          console.log('Event Log Response:', data);
        } catch (err) {
          console.error('Event Log Error:', err);
        }
      },
    }),
  }),
});

export const { useAddEventLogMutation } = eventsApi;
